import { Component, OnInit } from '@angular/core';
import { MkmService } from '../../../../services/mkm.service';
import { TzadikimModel } from '../../../../models/tz.model';
import { Router, ActivatedRoute } from '@angular/router';
import { TzadikimService } from '../../../../services/tz.service';
import { finalize } from 'rxjs'
import swal from "sweetalert2";
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    standalone: true,
    imports: [FormsModule, NgIf, NgForOf],
    providers: [TzadikimService, MkmService],
    selector: 'tzadikim-form',
    templateUrl: './tzadikim-form.component.html',
    styleUrls: ['./tzadikim-form.component.css']
})
export class TzadikimFormComponent implements OnInit {
    tz!: TzadikimModel;
    mkms!: any[];
    had!: string;
    errors!: string;
    isRequesting!: boolean;
    selectedFile!: File;

    constructor(private mkmService: MkmService, private tzadikimService: TzadikimService,
        private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        this.tz = new TzadikimModel();
        this.mkms = new Array<any>();
        this.tz.mkm.poi = '';

        this.route.params.subscribe(p => {
            this.tz.id = +p['id'];

            //console.log(p);

            if (this.tz.id) {
                this.getTzadikData();
            }

            else {
                this.tz.id = 0;
                this.had = 'New Tzadik';
                this.tz.subTitle = 'רבי  זצ"ל';
                this.tz.tzadikTitle = 'רבי';
                this.tz.tzadikBN = 'בן';
                this.tz.fathersTitle = 'רבי';
                this.tz.tzadikEndTitle = 'זצ"ל';
            }

        });

        this.mkmService.getMkmPoi().subscribe(m => {
            this.mkms = m;
        });
    }
    getTzadikData() {
        this.tzadikimService.getTzadik(this.tz.id).subscribe(t => {
            this.tz = t;
            this.had = 'Edit Tzadik';
        });
    }
    onMkmChange() {
        var m = this.mkms.find(m => m.id == this.tz.mkmId);
        this.tz.mkm.poi = m.poi;
    }

    onPoiChange() {
        var m = this.mkms.find(m => m.poi == this.tz.mkm.poi);
        this.tz.mkmId = m ? m.id : [];
    }

    submit() {
        if (this.tz.id) {
            this.isRequesting = true;
            this.errors = '';
            this.tzadikimService.update(this.tz)
                .pipe(finalize(() => this.isRequesting = false))
                .subscribe((t: any) => {
                    this.router.navigate(['/admin/tzadikim/index']);
                },
                    (errors: any) => this.errors = errors);
        }

        else {
            this.isRequesting = true;
            this.errors = '';
            this.tzadikimService.create(this.tz)
                .pipe(finalize(() => this.isRequesting = false))
                .subscribe(t => {
                    this.router.navigate(['/admin/tzadikim/index']);
                },
                    errors => this.errors = errors);
        }
    }
    handleOnChange(event: any) {
        const file = event.target.files[0];
        this.selectedFile = file;
        console.log(file, "upload image");
    }
    onDelete(id: number) {
        swal.fire({
            title: 'Are you sure you want to delete this image?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                // Call the delete service if confirmed
                this.mkmService.deleteMkmImage(id).subscribe(
                    res => {
                        console.log('Delete image success', res);
                        this.getTzadikData();
                    },
                    err => {
                        console.error('Delete image failed', err);
                    }
                );

                // Show success message
                swal.fire(
                    'Deleted!',
                    'The image has been deleted.',
                    'success'
                );
            }
        });
    }


    addImageIntoTzadikim() {

        if (this.tz.id && this.selectedFile) {
            this.mkmService.addImageIntoTzadikim(this.tz.id, this.selectedFile).subscribe(
                response => {
                    this.getTzadikData();
                    this.selectedFile = null;
                    const fileInput = document.getElementById('uploadImage') as HTMLInputElement;
                    if (fileInput) {
                        fileInput.value = '';
                    }
                },
                error => {
                    console.error(error);
                }
            );
        }
    }

}
